import { render, staticRenderFns } from "./ModalAgingRanges.vue?vue&type=template&id=107976e6&"
import script from "./ModalAgingRanges.vue?vue&type=script&lang=js&"
export * from "./ModalAgingRanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports